import {makeStyles, StepConnector, StepLabel, withStyles} from "@material-ui/core";

export const ColorlibConnector = withStyles({
  alternativeLabel: {
    marginTop: 8,
    fontSize: 16,
  },
  active: {
    '& $line': {
      backgroundColor: '#303F9F',
    },
  },
  completed: {
    '& $line': {
      backgroundColor: '#03A9F4'
    },
  },
  line: {
    height: 6,
    border: 0,
    backgroundColor: '#eaeaf0',
    borderRadius: 1,
    marginTop: 32,
  },
})(StepConnector);

export const ColorlibLabel = withStyles({
  alternativeLabel: {
    marginTop: '8px !important',
    fontSize: '16px !important'
  }
})(StepLabel);

export const useStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(2),
    minWidth: 400,
    maxWidth: 500,
    width: 400,
  },
  stepForm: {
    display: 'flex',
    flex: 2,
    flexDirection: 'column',
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 2,
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
  radioGroupLabel: {
    fontSize: 13,
    fontStyle: 'italic',
  },
  fileInput: {
    position: 'fixed',
    left: -1 * Number.MAX_VALUE,
  },
  mainButton: {
    '&:hover': {
      backgroundColor: '#03A9F4',
      borderColor: '#303F9F',
    }
  }
}));
